import styled from 'styled-components';

export const NewGeofenceButtonContainer = styled.div`
  margin-top: 18px;
`;
